/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "5be6dc99db095aeda71a6af9c40f019df72d6510";
